import { useEffect } from "react";
import EventsListRows from "./EventsListRows";
import { ip } from "../../../config";
import { useState } from "react";
import { ThreeDots } from 'react-loader-spinner'
import { Link } from 'react-router-dom';
import SpinLoader from '../../Miscel/SpinLoader.js';



const EventsList = () => {

    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState("loading");
    const [reloadEvents, setReloadEvents] = useState(0);
    const [eventsPage, setEventsPage] = useState(0);
    const [pageEnd, setPageEnd] = useState(false);

    useEffect(() => {
        fetch(ip + "/events?page=" + eventsPage + "&value=10&sort=alumniName", {
            method: "get",
        })
            .then(response => {
                if (response.status === 200) {
                    return response.json()
                } else {
                    throw new Error("An error occurred while fetching events");
                }
            }).then(response => {
                if (response.length < 10) setPageEnd(true);
                setEvents(response);
                setLoading(true);
            }).catch(response => {
                console.log(response);
            });
    }, [reloadEvents, eventsPage]);

    return (
        <>
            <div className='d-flex justify-content-end m-2' >

                <Link to='/add' className='btn btn-primary m-2'><i className="fa fa-plus" aria-hidden="true"></i> New Event</Link>

                <div style={{border: '3px solid #f8f9fa',borderRadius: '5px'}} className='d-flex'>
                    <button onClick={() => setEventsPage(eventsPage - 1)} className={'paginationBTN btn mt-2 mb-2 ' + (eventsPage == 0 ? 'disabled' : 'enabled')}>
                        <i className="fa-solid fa-chevron-left"></i> Prev
                    </button>
                    <input type="number" value={eventsPage + 1} className="form-control mt-2 mb-2" id="eventsPageNo" style={{ width: '50px' }} />
                    <button onClick={() => setEventsPage(eventsPage + 1)} className={'paginationBTN btn mt-2 mb-2 ' + (pageEnd == true ? 'disabled' : 'enabled')}>
                        Next <i className="fa-solid fa-chevron-right"></i>
                    </button>
                </div>

            </div>

            {loading === "blankScreen" && <div id="loader" className=''><SpinLoader /></div>}

            <table className="table table-striped">
                <thead>
                    <tr>
                        <th scope="col">#ID</th>
                        <th scope="col">Purpose</th>
                        <th scope="col">Publisher</th>
                        <th scope="col">Start Date</th>
                        <th scope="col">End Date</th>
                        <th scope="col"></th>
                    </tr>
                </thead>

                <tbody>
                    {events && <EventsListRows key={214} rows={events} refresh={setLoading} reload={setReloadEvents} />}
                </tbody>


            </table>
            <div>
                <div className="d-flex justify-content-center align-items-center">
                    {loading === "loading" && <ThreeDots height="100" width="100" color='grey' ariaLabel='loading' />}
                    {(loading !== "loading" && events.length === 0) && <h2>No Events Found</h2>}
                </div>
            </div>
        </>
    );
}

export default EventsList;